import modules from './modules';

export default {
  state: {},
  mutations: {},
  actions: {},
  modules
};
